import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmationDialogData {
  message: string;
  showCheckbox?: boolean;
  checkboxText?: string;
  imagePath?: string;
  confirmButtonText?: string; // Default: 'Yes'
  cancelButtonText?: string;  // Default: 'No'
  variant?: 'default' | 'danger'; // 'danger': small icon and a red confirm button
}

export interface ConfirmationDialogResult {
  buttonPressed: 'yes' | 'no' | 'cancel';
  checkboxChecked: boolean;
}

@Component({
  selector: 'hmt-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: false
})
export class ConfirmationDialogComponent {
  checkboxChecked: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {
    // Set default button text if not provided
    this.data.confirmButtonText = this.data.confirmButtonText || 'Yes';
    this.data.cancelButtonText = this.data.cancelButtonText || 'No';
    
    // Set default checkbox state based on Figma design (checked by default)
    if (data.showCheckbox) {
      this.checkboxChecked = true;
    }
  }

  onYesClick(): void {
    const result: ConfirmationDialogResult = {
      buttonPressed: 'yes',
      checkboxChecked: this.checkboxChecked
    };
    this.dialogRef.close(result);
  }

  onNoClick(): void {
    const result: ConfirmationDialogResult = {
      buttonPressed: 'no',
      checkboxChecked: this.checkboxChecked
    };
    this.dialogRef.close(result);
  }

  onCancel(): void {
    const result: ConfirmationDialogResult = {
      buttonPressed: 'cancel',
      checkboxChecked: this.checkboxChecked
    };
    this.dialogRef.close(result);
  }
}

